import { FC, useCallback } from "react";
import Stack from "@mui/material/Stack";
import { CircularProgress, Typography } from "@mui/material";
import { FilterTree } from "@/components/pages/common/filters-tree/filters-selection/FilterTree";
import {
  FilterGroupNodeWithId,
  FilterTreeNodeWithId,
} from "@/components/pages/common/filters-tree/utils/types/common";
import { DimensionsFilterValueOption } from "@/components/pages/dimensions/components/form-drawer/components/dimension/categories/DimensionsFilterValueOption";
import { useGetUsersMeOrganisationsCurrentResourceExplorerPossibleFiltersQuery } from "@/services/cloudchipr.api";
import { useAppDispatch } from "@/store/hooks";
import { updateSharedCost } from "@/store/dimensions/dimensionsSlice";

interface DimensionCostAllocationCardFiltersProps {
  sharedCostId: string;
  sharedCostFilters: FilterTreeNodeWithId;
}

export const DimensionCostAllocationCardFilters: FC<
  DimensionCostAllocationCardFiltersProps
> = ({ sharedCostFilters, sharedCostId }) => {
  const dispatch = useAppDispatch();

  const { data, isLoading } =
    useGetUsersMeOrganisationsCurrentResourceExplorerPossibleFiltersQuery({});

  const filterTreeChangeHandler = useCallback(
    (filterTree: FilterGroupNodeWithId) => {
      dispatch(
        updateSharedCost({
          id: sharedCostId,
          filter_tree: filterTree,
        }),
      );
    },
    [dispatch, sharedCostId],
  );

  return (
    <Stack spacing={1}>
      <Typography variant="body2">1. Define the Shared Cost Scope</Typography>
      <Typography variant="caption" pl={2} color="text.secondary">
        Use filters to define the scope of costs that should be allocated across
        categories in this Dimension
      </Typography>

      {isLoading ? (
        <Stack alignItems="center" padding={2}>
          <CircularProgress />
        </Stack>
      ) : (
        <FilterTree
          possibleFilters={data ?? []}
          filterTree={sharedCostFilters}
          setFilters={filterTreeChangeHandler}
          renderFilterValueOption={DimensionsFilterValueOption}
        />
      )}
    </Stack>
  );
};
